import { Close } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import { closeSnackbar, SnackbarKey, SnackbarProviderProps } from "notistack"

const snackbar = (snackbarId: SnackbarKey) => (
  <IconButton
    onClick={() => closeSnackbar(snackbarId)}
    size="small"
    sx={{ color: "white" }}
  >
    <Close />
  </IconButton>
)

const snackbarConfig: SnackbarProviderProps = {
  maxSnack: 3,
  anchorOrigin: { vertical: "top", horizontal: "center" },
  action: (s) => snackbar(s),
  autoHideDuration: 2000,
}

export default snackbarConfig
